import React, { useEffect, useState } from "react";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import OwlCarousel from "react-owl-carousel";
import tpa from "../../images/unnamed 1.svg";
import qr1 from "../../images/image 1.svg";
import qr2 from "../../images/image 2.svg";
import downloadApp from "../../images/download-app.png";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import styles from "./policySubmitStatus-styles.module.css";
import "../PolicyDetail/policyDetail-styles.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  getPolicyDetailAPI,
  getParameterAPI,
} from "../PolicyDetail/PolicyDetailService/policyDetailService";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import CryptoJS from "crypto-js";
import { CurrencyFormater, CurrencyFormaterNonDec } from "../../util";
import {
  Grid,
  Backdrop,
  CircularProgress,
  Typography,
  Card,
  CardContent,
} from "@mui/material";

const PolicyDetail = () => {
  // const searchParams = new URLSearchParams(window.location.search);
  // const channelType = searchParams.get("channelType");
  let [searchParams, setSearchParams] = useSearchParams();

  const policyNo = searchParams.get("policyNo") || "";
  const insureIdCard = localStorage.getItem("customer_id") || "";

  const [activeTab, setActiveTab] = useState("home");
  const [policy, setPolicy] = useState("");
  const [LoadingContent, setLoadingContent] = useState(true);
  const [InfomationPolicy, setInformationPolicy] = useState("");
  const [beneficiaries, setBeneficiaries] = useState("");
  const [riders, setRiders] = useState([""]);
  const [lnkHosp, setLnkHosp] = useState("");
  const [lnkForm, setLnkForm] = useState("");
  const [cusTel, setCusTel] = useState("");
  let navigate = useNavigate();
  const [slideRiders, setSlideRiders] = useState(
    riders.length > 0 ? riders[0] : ""
  );
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [ridersStatus, setRidersStatus] = useState("");
  const [ridersCode, setRidersCode] = useState("");
  const allowedCodes = [
    "HS",
    "HP",
    "HSM",
    "OPD",
    "PA",
    "MEMAX",
    "MEPRO",
    "HABMAX",
  ];
  const [ridersIndex, setRidersIndex] = useState("");

  useEffect(() => {
    fetchPolicyDetailAPI();
    getLnk();
    getTel();
  }, []);

  const handleSlideChangeInternal = async (e) => {
    if (riders.length > 0) {
      setSelectedIndex(e);
      setRidersIndex(riders[e]);
    }
  };

  const handleSelect = (key) => {
    setActiveTab(key);
  };

  const fetchPolicyDetailAPI = async () => {
    const result = await getPolicyDetailAPI(
      policyNo,
      decryptCardNumber(insureIdCard, process.env.REACT_APP_ENCRYPT_DATA)
    );
    // console.log(result);
    if (result.status) {
      setLoadingContent(false);
      setInformationPolicy(result.data);
      setBeneficiaries(result.data.beneficiaries);
      setRiders(result.data.riders);
      setRidersIndex(result.data.riders[selectedIndex]);
      // console.log(result.data.riders[selectedIndex]);
    }
  };

  const getLnk = async () => {
    const result = await getParameterAPI(11);
    if (result.success) {
      const payload = result.payload;
      const lnkHospital = payload.find((item) => item.code === "LINK_HOSPITAL");
      const lnkForm = payload.find((item) => item.code === "LINK_FORM");

      const lnkHosp = lnkHospital.variable1;
      const lnkF = lnkForm.variable1;
      setLnkHosp(lnkHosp);
      setLnkForm(lnkF);
    }
  };

  const getTel = async () => {
    const result = await getParameterAPI(12);
    const payload = result.payload;
    const cusTel = payload.find((item) => item.code === "CUS_SERV_TEL");
    const variable1 = cusTel.variable1;
    setCusTel(variable1);
  };

  const goToPolicyList = () => {
    navigate("/policylist");
  };

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 2, pagination: false },
    { width: 850, itemsToShow: 3 },
    { width: 1150, itemsToShow: 4, itemsToScroll: 2 },
    { width: 1450, itemsToShow: 5 },
    { width: 1750, itemsToShow: 6 },
  ];

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  return (
    <div>
      <Header_Home />
      {/* <Header title="รายละเอียดกรมธรรม์" /> */}
      <div className="top" style={{ marginBottom: "25px" }}>
        <section className="sec-navbar">
          <nav
            style={{
              backgroundColor: "#FF5E43",
              color: "white",
              height: "50px",
            }}
          >
            <div style={{ padding: "10px" }}>
              <h5 className="flex-shrink-1 text-center bold">
              สถานะการจัดส่งเล่มกรมธรรม์
              </h5>
            </div>
          </nav>
        </section>
      </div>
      <div className="containers">
        {LoadingContent && (
          <>
            <Row className="card-custom3 d-flex">
              <Col className="mt-3">
                <Skeleton style={{ height: "30px" }} />
                <div className="d-flex flex-row justify-content-between">
                  <Skeleton />
                </div>
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </Col>
            </Row>
            <br />
          </>
        )}
        <div>
          {!LoadingContent && InfomationPolicy && (
            <div className="frame-policy-new">
              <ul className="list-group">
                <h2
                  className="bold-detail"
                  style={{
                    fontSize: "20px",
                    marginLeft: "20px",
                    marginTop: "20px",
                  }}
                >
                  {InfomationPolicy && InfomationPolicy.baseName}
                </h2>
                <hr
                      style={{
                        margin: "0px 10px 15px 20px",
                        border: "solid 1px",
                        borderTop: 0.1,
                      }}
                    />
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={3}>
                    <span className="font-size-labels">กรมธรรม์เลขที่</span>
                  </Grid>
                  <Grid item xs={6} sm={3} style={{ textAlign: "right" }}>
                    <span className="bold-detail">
                      {InfomationPolicy.policyNo}
                    </span>
                  </Grid>

                  <Grid item xs={6} sm={3}>
                    <span className="font-size-labels">วันที่ส่งเล่มกรมธรรม์</span>
                  </Grid>
                  <Grid item xs={6} sm={3} style={{ textAlign: "right" }}>
                    <span className="bold-detail">
                      {InfomationPolicy.policySendingSendDate}
                    </span>
                  </Grid>

                  <Grid item xs={6} sm={3}>
                    <span className="font-size-labels">สถานะการจัดส่ง</span>
                  </Grid>
                  <Grid item xs={6} sm={3} style={{ textAlign: "right" }}>
                    <span className="bold-detail">
                      {InfomationPolicy.policySendingStatus}
                    </span>
                  </Grid>

                  <Grid item xs={6} sm={3}>
                    <span className="font-size-labels">
                    วันที่เซ็นรับ
                    </span>
                  </Grid>
                  <Grid item xs={6} sm={3} style={{ textAlign: "right" }}>
                    <span className="bold-detail">
                      {InfomationPolicy.policySendingReceiveDate} 
                    </span>
                  </Grid>

                  <Grid item xs={6} sm={3}>
                    <span className="font-size-labels">
                    ผู้เซ็นรับ
                    </span>
                  </Grid>
                  <Grid item xs={6} sm={3} style={{ textAlign: "right" }}>
                    <span className="bold-detail">
                      {InfomationPolicy.policySendingReceiveName}
                    </span>
                  </Grid>

                  <Grid item xs={6} sm={3}>
                    <span className="font-size-labels">ความสัมพันธิ์</span>
                  </Grid>
                  <Grid item xs={6} sm={3} style={{ textAlign: "right" }}>
                    <span className="bold-detail">
                      {InfomationPolicy.policySendingReceiveRelation}
                    </span>
                  </Grid>
                </Grid>
              </ul>
              <br />
            </div>
          )}
          <div className="App" style={{ marginBottom: "70px" }}>
            <div className="d-flex justify-content-center flex-wrap">
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={6}>
                  <button
                    onClick={goToPolicyList}
                    type="button"
                    className="btn-checkout-back w-100 p-2 bold-detail"
                  >
                    ย้อนกลับ
                  </button>
                </Grid>
              </Grid>
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};

export default PolicyDetail;
